<template>
    <v-app>
        <v-app-bar color="#000060">
            <template v-slot:prepend>
                <v-img :width="156" aspect-ratio="16/9" cover
                    src="https://sistemacarnet.sansalvadorsur.gob.sv/storage/images/logo.png"></v-img>
            </template>
            <template v-slot:append>
                <v-btn prepend-icon="mdi mdi-logout" @click="logout"
                v-if="this.$store.getters.getUser!=null">
                Logout</v-btn>
            </template>
        </v-app-bar>
        <v-navigation-drawer expand-on-hover rail color="#000060"
        v-if="this.$store.getters.getUser!=null">
            <!-- items -->
            <v-list>
                <v-list-item prepend-icon="mdi mdi-office-building-outline" title="Sistema de Carnets"
                    subtitle="San Salvador Sur"></v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-list density="compact" nav>
                <v-list-item prepend-icon="mdi mdi-badge-account" to="/carnet" title="Carnets"></v-list-item>
                <v-list-item 
                v-if="this.$store.getters.getUser!=null && this.$store.getters.getRol==1"
                prepend-icon="mdi mdi-account-group" to="/user" title="Usuarios"></v-list-item>
            </v-list>
        </v-navigation-drawer>
        <v-main>
            <router-view />
        </v-main>
    </v-app>
</template>

<script>

export default {
    name: 'App',
    data() {
        return {
            drawer: true
        }
    },
    methods: {
        logout() {
            this.$store.dispatch('logout');
            this.$router.push('/login');
        },
        autenticar() {
            let data = localStorage.getItem('userData');
            if (data) {
                this.$store.dispatch('login', JSON.parse(data));
                this.$router.push("/carnet");
            } else {
                this.$router.push("/login");
            }
        }
    },
    created() {
        this.autenticar();
    }
}
</script>
